import React, { createContext, useEffect, useState, ReactNode, useInsertionEffect, useContext, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import config from "../config";
import { createSelector } from "reselect";
import { useProfile, useRedux } from "../hooks/index";
import { useLocation } from 'react-router-dom';
import { Exception } from 'sass';
import {
  chatsApiResponseSuccess, setRespEmojiWhMsg, changeGroupFullName, unsendMessage
  , updateSentFlag
} from "../redux/chats/actions";
import { appendPostConver, setPostInfoOnSignalR, apiOk, updatePostUnreadCount, getRoleUnreadCount, setTagUnreadOnSignalR, loadPostTitleActionV2, setActivePostId2, togglePostEmoji, markPostUnSend, setPostInfoOnly } from "../redux/workplace/wpActions";
import { swapChatRooms, fetchChatContactsRequest } from "../redux/chats/slice";
import { WpSliceData, WpMemberRoleUnread, WpActionTypes, WpPostType, WpEmpFilterType, WorkPlaceTagUnreadSignalR } from "../redux/workplace/wpTypes";
import { ChatsActionTypes } from "../redux/chats/types";
import { ADD_2S_TYPE } from "../../src/redux/chats/types";
import { debounce } from "lodash";
import type { DebouncedFunc } from "lodash";

import {
  addMessage2s, setGlobalError, getChatUserConversations2, updateUnreadCount
  , updateReadPcntOnMsg
  , getChatRoomLists
} from "../redux/actions";


import {
  updateUnreadCount as sl2_updateUnreadCount,
  swapChatToTop as sl2_swapChatToTop,
  ChatContact2,
  changeGroupFullName as sl12_changeGroupFullName,
  markReadAll

} from "../redux/chats/slice";

import { Utils } from 'helpers/utils';
import { APIClient } from 'api/apiCore';
import { Util } from 'reactstrap';
import { Const } from 'const';
import { TABS, WpModes } from '../../src/constants';
import { UserTypes } from '../api';


// Define the context type
interface SignalRContextType {
  connection: signalR.HubConnection | null;
  sendMessage: (message: string) => Promise<string>; // Method to send messages
}

// Create a SignalR Context
const SignalRContext = createContext<SignalRContextType | undefined>(undefined);

// Custom hook to use SignalR in child components
export const useSignalR = () => {
  const context = useContext(SignalRContext);
  if (!context) {
    throw new Error("useSignalR must be used within a SignalRProvider");
  }
  return context;
};
const errorData = createSelector(
  (state: any) => state.Profile2,
  (state: any) => state.Chats,
  (state: any) => state.WpSlice,
  (state: any) => state.Layout,
  (profile2, chat2, wp: WpSliceData, layout) => ({
    lastLogonDate: profile2.lastLogonDate,
    chatUserDetails: chat2,
    conversionId: chat2.chatUserDetails.id,
    selectedChat: chat2.selectedChat,
    p2PictureUrl: profile2.pictureUrl,
    activePostId: wp.activePostInfo.postId,
    activeTab: layout.activeTab
  })
);

export const SignalRProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { dispatch, useAppSelector } = useRedux();
  const [connection, setConnection] = useState<signalR.HubConnection | null>(null);
  const { lastLogonDate, chatUserDetails, conversionId, selectedChat, activePostId, p2PictureUrl, activeTab } = useAppSelector(errorData);
  const conversionIdRef = useRef(conversionId);
  const selectedChatRef = useRef(selectedChat);
  const activePostIdRef = useRef(activePostId);
  const activeTabRef = useRef(activeTab);
  // console.log('chat redux:', chat);
  const [lastConnectDate, setLastConnectDate] = useState(null);
  const location = useLocation(); // Hook to get current location object

  useEffect(() => {
    conversionIdRef.current = conversionId;
    // console.log('Signal R change conversionId = ' + conversionId);
  }, [conversionId]);

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  useEffect(() => {
    selectedChatRef.current = selectedChat;
    // console.log('Signal R change selectedChat = ' + selectedChat);
  }, [selectedChat]);

  useEffect(() => {
    activePostIdRef.current = activePostId;
  }, [activePostId]);

  // console.log('SignalR Connection Called = ' + lastLogonDate);

  const fnGetWpMode = (): WpModes => {
    if (activeTabRef.current == TABS.WORKPLACE) return WpModes.Workplace;
    else if (activeTabRef.current == TABS.TASK) return WpModes.Task;
    else return WpModes.Workplace;
  }

  const debouncedDispatchRef = useRef<DebouncedFunc<(data: WorkPlaceTagUnreadSignalR[]) => void> | null>(null);
  useEffect(() => {
    debouncedDispatchRef.current = debounce(
      (data: WorkPlaceTagUnreadSignalR[]) => {
        dispatch(setTagUnreadOnSignalR(data));
      },
      300
    );

    return () => {
      debouncedDispatchRef.current?.cancel();
    };
  }, [dispatch]);

  useEffect(() => {
    //dispatch(setGlobalError('Chat disabled because offline'));
    //console.log('SignalR Connection Called = ' + lastLogonDate);
    if (lastLogonDate && lastConnectDate != lastLogonDate) {
      dispatch(setGlobalError('กำลังเชื่อมต่อระบบแชท'));
      setLastConnectDate(lastLogonDate);
      const jwtToken = Utils.JwtTokenGet();
      // console.log('signal R connect with token = ' + jwtToken);
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(config.API_URL + "/chatHub", { // URL to your backend
          accessTokenFactory: () => jwtToken, // ✅ Supply the token here
        })
        .withAutomaticReconnect()
        .build();

      setConnection(newConnection)

      // Start the connection
      newConnection.start()
        .then(() => {
          //console.log("Connected to SignalR " + lastLogonDate);
          dispatch(setGlobalError(''));
          if (selectedChatRef && selectedChatRef.current) {
            //console.log('reload chat conversion of room: ', selectedChatRef.current);
            dispatch(getChatUserConversations2(selectedChatRef.current, null, null, null, null, null, "SignalR start"));
          }
        })
        .catch(err => {
          dispatch(setGlobalError('ยังไม่ได้ล็อกอิน <a href="#" onclick="window.location.reload(); return false;">แสดงใหม่</a>'));
          console.error("Connection error: ", err);
        });

      newConnection.on("MarkReadAll", (data: any) => {
        // console.log("MarkReadAll:", data);
        dispatch(markReadAll({ userOrGroupId: data.userOrGroupId }));
      });

      // Listen for incoming messages
      newConnection.on("ReceiveMessage", (message: string) => {
        const newMsgFromServ = (message as any).messages[0];
        // console.log('receiveMessage:', newMsgFromServ);
        // console.log(newMsgFromServ.conversationId, conversionIdRef?.current);
        newMsgFromServ.htmlContent = Utils.ChangePdfLinkHref(newMsgFromServ.htmlContent);
        newMsgFromServ.isRead = newMsgFromServ.isFromMe; // 20250706, add this code becuase send quick reply and that message will display in my chat from signalR, then if isFrom me then set isRead = true
        const newText = newMsgFromServ.lastChatText;
        const newImage = newMsgFromServ.image && newMsgFromServ.image.length > 0 ? 'รูปภาพใหม่' : '';
        const newFile = newMsgFromServ.attachments && newMsgFromServ.attachments.length > 0 ? 'เอกสารใหม่' : '';
        const newTextShow = newText ? newText : (newImage ? newImage : newFile);

        //dispatch(updateUnreadCount(newMsgFromServ.conversationId, newMsgFromServ.unreadCount, newMsgFromServ.unreadTagMe, newTextShow, newMsgFromServ.lastChatTime)); // update unread count , 20250915 comment seem this code not use
        dispatch(sl2_updateUnreadCount({
          userId: newMsgFromServ.conversationId,
          unreadCount: newMsgFromServ.unreadCount,
          unreadTagMe: newMsgFromServ.unreadTagMe,
          lastChatText: newTextShow,
          lastChatTime: newMsgFromServ.lastChatTime
        }));

        //if (newMsgFromServ.conversationId == conversionIdRef?.current) { // show the conversion same page
        // const groupType = activeTabRef.current == TABS.CHAT_SUP ? UserTypes.GroupSupplier : UserTypes.Group;
        const groupType = newMsgFromServ.groupType;// 20250915
        if (newMsgFromServ.conversationId == (selectedChatRef?.current ?? -1)) { // 20250827 seem when swap chat, the selectedChat will be change before conversaionId
          // console.log('newMsgFromServbbb:', newMsgFromServ);
          // if (newMsgFromServ.readerPcnt == null) newMsgFromServ.readerPcnt = 75;
          const newMsg: ChatContact2 = { // 20250224 modify swap to too too even its already in chatting room
            userId: newMsgFromServ.conversationId,
            unreadCount: newMsgFromServ.unreadCount,
            lastChatText: newTextShow,
            lastChatTime: newMsgFromServ.lastChatTime,
            abbrName: newMsgFromServ.senderAbbrName,
            bgColor: newMsgFromServ.senderForeColor,
            foreColor: newMsgFromServ.senderBgColor,
            isFavorite: false,
            fullName: newMsgFromServ.senderName,
            profileImage: newMsgFromServ.senderPictureUrl,
          };
          dispatch(sl2_swapChatToTop({ groupType: groupType, newMsg: newMsg }));

          dispatch(addMessage2s(newMsgFromServ, 'New message'));
        } else {
          const newMsg: ChatContact2 = {
            userId: newMsgFromServ.conversationId,
            unreadCount: newMsgFromServ.unreadCount,
            lastChatText: newTextShow,
            lastChatTime: newMsgFromServ.lastChatTime,
            abbrName: newMsgFromServ.senderAbbrName,
            bgColor: newMsgFromServ.senderForeColor,
            foreColor: newMsgFromServ.senderBgColor,
            isFavorite: false,
            // fullName: newMsgFromServ.senderName,
            fullName: newMsgFromServ.groupName, // 20250717
            profileImage: newMsgFromServ.senderPictureUrl,
            companyId: newMsgFromServ.companyId, // 20250717
            isSaleCorrect: true, // 20250717 just temporary set when room not in list 
            isCsCorrect: true // 20250717 just temporary set when room not in list 
          };
          dispatch(sl2_swapChatToTop({ groupType: groupType, newMsg: newMsg }));
          // // put badge at conversion
          // console.log('dispatch unread:', newMsgFromServ.conversationId, newMsgFromServ.unreadCount);
          // dispatch(updateUnreadCount(newMsgFromServ.conversationId, newMsgFromServ.unreadCount));
        }

        // additional action
        if (newMsgFromServ.tag && newMsgFromServ.tag?.type == Const.MSG_LOG_ACTION_CHANGE_GROUP_NAME) {
          const groupId = newMsgFromServ.tag?.groupId;
          const groupName = newMsgFromServ.tag?.groupName;
          if (groupId && groupName) { // dispatch to change group full name
            dispatch(changeGroupFullName(groupId, groupName));
            dispatch(sl12_changeGroupFullName({ groupId: groupId, fullName: groupName }));
          }
        }
      });

      newConnection.on("ReceiveMessageWp", (post: any) => {
        try {
          // console.log('ReceiveMessageWp:', post);
          //if (post.deviceId != Utils.GetDeviceId()) {
          if (post.convers) {
            if (
              post.deviceId != Utils.GetDeviceId()
              || post.convers.postType == WpPostType.ChangeStatus
              || post.convers.postType == WpPostType.RemoveTag //20260106
              || post.convers.postType == WpPostType.ChangePostInfo // 20260109
            ) {
              dispatch(appendPostConver([post.convers]));
            }
          }
          const lastChatImg = post.convers ? post.convers.pictureUrl : post.postInfoParent.abbrName;
          // console.log('dispatch post title from signal R');
          dispatch(setPostInfoOnSignalR(post.postInfoParent, post.lastChatText, post.lastChatTime, lastChatImg/*post.convers.pictureUrl*/, post.unreadCount, post.memberRoles));
          // dispatch(getRoleUnreadCount(false)); -> อันนี้ไม่ work เพราะถ้า user เดียวกัน online หลายเครื่อง ก็จะยิงคำสั่งไปที่ api เยอะเกิน
        } catch (e) {
          Utils.HandleException(e, false);
        }
      });

      newConnection.on("PostInfo", (postInfo: any) => {
        try {
          // console.log('PostInfo:', postInfo);
          dispatch(setPostInfoOnly(postInfo));
          //dispatch(setPostInfoOnSignalR(postInfo, postInfo.lastChatText, postInfo.lastChatTime, postInfo.lastChatImg/*post.convers.pictureUrl*/, postInfo.unreadCount, postInfo.memberRoles));
        } catch (e) {
          Utils.HandleException(e, false);
        }
      });

      newConnection.on("UpdateMyUnreadCountWp", (data: any) => {
        try {
          // console.log('UpdateMyUnreadCountWp:', data);
          dispatch(updatePostUnreadCount(data.wpMode, data.postId, data.memberId, data.unreadCount));
        } catch (e) {
          Utils.HandleException(e, false);
        }
      });

      newConnection.on("Wp_UnreadByRole", (data: any) => {
        try {
          const unread = data as WpMemberRoleUnread;
          // console.log('Wp_UnreadByRole:', unread);
          dispatch(apiOk(WpActionTypes.GET_ROLE_UNREAD_COUNT, unread));
          if (unread.reloadTitle) {
            const wpMode = fnGetWpMode();
            const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
            dispatch(loadPostTitleActionV2(wpMode, "", [], memberRole, null, false, false, WpEmpFilterType.Poster, null, "SignalR_Wp_UnreadByRole"));
          }
        } catch (e) {
          Utils.HandleException(e, false);
        }
      });

      newConnection.on("Wp_UnreadByTag", (data: any) => {
        try {
          const data2: WorkPlaceTagUnreadSignalR[] = data;
          // console.log('Wp_UnreadByTag:', data2);
          debouncedDispatchRef.current?.(data2);
          // dispatch(setTagUnreadOnSignalR(data2));
        } catch (e) {
          Utils.HandleException(e, false);
        }
      });

      newConnection.on("Ntc_NewNotify", (data:any) => {
        console.log('Ntc_NewNotify:', data);
      })


      newConnection.on("OtherReadMyMessage", (msgs: any) => {
        //console.log('OtherReadMyMessage:', msgs);
        dispatch(updateReadPcntOnMsg(msgs));
      });

      newConnection.on("UpdateMyUnRead", (chats: any) => {
        // console.log('UpdateMyUnread:', chats);
        if (chats && chats.length > 0) {
          for (var i = 0; i < chats.length; ++i) {
            dispatch(updateUnreadCount(chats[i].userOrGroupId, chats[i].unreadCount, chats[i].unreadTagMe, null, null)); // update unread count
            dispatch(sl2_updateUnreadCount({
              userId: chats[i].userOrGroupId,
              unreadCount: chats[i].unreadCount,
              unreadTagMe: chats[i].unreadTagMe,
              lastChatText: "",
              lastChatTime: ""
            }));
          }
        }
        // console.log('UpdateMyUnRead:', chats);
      });

      newConnection.on("SetRespEmoji", (msgId: any, resp: any) => {
        try {
          dispatch(setRespEmojiWhMsg(msgId, resp));
        } catch (e) {
          console.error(e);
        }
      })

      newConnection.on("WpSetRespEmoji", (postIdParent: any, resp: any) => {
        try {
          // console.log('WpSetRespEmoji:', { resp });
          dispatch(togglePostEmoji(resp.postIdParent, resp.postId, resp.emojiName, resp.emoji, resp.isAdd, resp.memberNames));
        } catch (e) {
          console.error(e);
        }
      })

      newConnection.on("WpUnsendPost", (wpMode: WpModes, postIdParent: string, postId: string, isDelPost: boolean) => {
        try {
          // console.log('WpUnsendPost:', { postIdParent, postId, isDelPost });
          dispatch(markPostUnSend(wpMode, postIdParent, postId, isDelPost));
          if (isDelPost && activePostIdRef && activePostIdRef.current) {
            dispatch(setActivePostId2(fnGetWpMode(), null, null, null, null, null, "SignalR unsend post"));
          }
        } catch (e) {
          console.error(e);
        }
      })


      newConnection.on("SetUnsendMessage", (msgId: any) => {
        try {
          // console.log("SetUnsendMessage:", msgId);
          dispatch(unsendMessage(msgId));
          // dispatch(setRespEmojiWhMsg(msgId, resp));
        } catch (e) {
          console.error(e);
        }
      })

      newConnection.on("ReloadMessage", () => { // reload chat message
        //console.log('dispatch(getChatUserConversations(selectedChatRef.current, null, null));');
        dispatch(getChatUserConversations2(selectedChatRef.current, null, null, null, null, null, "SignalR reload message"));
      });

      // Handle when the connection is closed
      newConnection.onclose((error) => {
        if (error) {
          console.error("Connection closed due to error: ", error);
        } else {
          //console.log("Connection closed normally.");
        }
        dispatch(setGlobalError(Utils.MSG_CHAT_DISCONNECT));
      });

      // Handle reconnection attempts
      newConnection.onreconnecting((error) => {
        //console.log('SignalR: Connection lost. Reconnecting...');
        dispatch(setGlobalError(Utils.MSG_CHAT_CONNECTING));
      });

      // Handle when the connection is reconnected
      newConnection.onreconnected((connectionId) => {
        dispatch(setGlobalError(''));
        try {
          //console.log('reload chat room after re-connect');
          //#define DEBUG USE NEW VERSION dispatch(getChatRoomLists());
        } catch (e) {
          alert((e as Error).message);
        }
        if (selectedChatRef && selectedChatRef.current) {
          // console.log('reload chat conversion of room :', selectedChatRef.current);
          dispatch(getChatUserConversations2(selectedChatRef.current, null, null, null, null, null, "SignalR on reconnected"));
        }

        // console.log('reload chat room after signalR recoonected, current chat = ' + selectedChatRef.current);
        // 20250224 reload chat room after signalr reconnect
        const parm = {
          page: 1,
          filter: '',
          isFetchNext: false,
          // filterUnread: null,
          // filterPersonUnRead: filterChatRoom.personUnRead,
          // filterNoActivity: filterChatRoom.noActivity,
          // filterSaleIds: filterSaleId,
          // filterCsIds: filterCsId,
          // filterProvinceIds: filterProvinceId,
          groupType: activeTabRef.current == TABS.CHAT_SUP ? UserTypes.GroupSupplier : UserTypes.Group,
          currentSelectedChatId: selectedChatRef.current
        }
        // console.log('filter parm:', parm);
        dispatch(fetchChatContactsRequest(parm));

        // reload workplace title
        const wpMode = fnGetWpMode();
        const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
        if (memberRole) {
          dispatch(loadPostTitleActionV2(wpMode, "", [], memberRole, null, false, false, WpEmpFilterType.Poster, null, "SignalR OnReconnect"));
        }
        if (activePostIdRef && activePostIdRef.current) {
          // console.log('reload post conversion of room :', activePostIdRef.current);
          dispatch(setActivePostId2(wpMode, activePostIdRef.current, null, null, null, null, "On SignalR re-connect"));
        }


      });

      //console.log('signal R connected ' + lastLogonDate); 

      return () => {
        if (newConnection) {
          newConnection.off("ReceiveMessage"); // Remove the listener
          newConnection.stop();
        }
      };
    } else {
      //console.log("Connected to SignalR - Already connected ");
      dispatch(setGlobalError(''));
    }
  }, [lastLogonDate]);

  // Function to send a message
  const sendMessage = async (message: any): Promise<string> => {
    //console.log('SignalR:sendMessage:', message);

    if (connection && connection.state === signalR.HubConnectionState.Connected) {
      try {
        // immediately add chat to the conversion
        let text = message.text;
        if (!text && message.attachments && message.attachments.length > 0) text = 'กำลังส่งไฟล์';
        dispatch(addMessage2s({
          mId: message.Uid,
          text: text,/*message.text,*/
          tagNames: message.tagNames,
          isFromMe: true,
          time: Utils.GetCurrentDateTimeLongFormat(),
          senderName: "xxx",
          senderImg: p2PictureUrl,
          meta: {
            receiver: message.SendToId,
            sender: -1,
            senderName: "dummy",
            sent: false,
            received: false,
            read: false,
            isForwarded: false,
            userData: null
          },
          conversationId: -1,
          conversion: null,
          replyOf: message.replyOf
        }, 'I Add'));

        let sendErr = '';
        if (message.attachments && message.attachments.length > 0) { // upload file
          //console.log('send file:', message.attachments);
          const api = new APIClient

          // Upload each Blob URL asynchronously
          const uploadPromises = message.attachments.map((blob: { downloadLink: string; id: number; name: string }) => {
            return api.uploadFile(blob.downloadLink, blob.id, blob.name, message.Uid)
              .then((err: string) => {
                if (err) {
                  const bot = Utils.CreateChatBotMessage('🚫 ' + blob.name + ':' + err);
                  //console.log(bot);
                  dispatch(addMessage2s(bot, 'Bot'));
                  return false;
                } else {
                  return true;
                }
              });
          });

          // Wait for all uploads to complete
          const results = await Promise.all(uploadPromises);
          //console.log(results);
          const successCount = results.filter(result => result).length;
          //console.log('upload file done:', successCount, successCount);
          if (successCount > 0) {
            message.attachments = null;
            message.image = "image";
            sendErr = await connection.invoke("SendMessage", message);
          }
        } else {
          sendErr = await connection.invoke("SendMessage", message); // call signal r to send realtime message to server
        }
        if (sendErr != '') {
          console.error('sendErr = ' + sendErr);
        }
        // console.log('test reload full message after send message');
        // dispatch(getChatUserConversations(selectedChatRef.current, null, null));
        if (sendErr) {
          //alert('ส่งข้อความไม่ได้<br/>' + sendErr + '<br/>กรุณาลองใหม่');
        } else {
          dispatch(updateSentFlag(message.Uid));
        }


        return sendErr;
      } catch (error) {
        console.error("Error sending message: ", error);
        const errMsg = (error as Exception).message;
        if (errMsg.includes('because user is unauthorized')) {
          return 'Not yet logon to server, your logon session/token may expired. Please re-logon';
        } else {

          return (error as Exception).message;
        }
      }
    } else {
      return "No open connection";
    }
  };

  // useEffect(() => {
  //     console.log('SignalRContext - Location Changed, user id = ', profile2.userId);

  // }, [location]);


  // useEffect(() => {
  //     console.log('logon user name = ' + logonUserName);
  //     if (logonUserName) {
  //         const newConnection = new signalR.HubConnectionBuilder()
  //             .withUrl(config.API_URL + "/chatHub") // URL to your backend
  //             .withAutomaticReconnect()
  //             .build();

  //         setConnection(newConnection)

  //         // Start the connection
  //         newConnection.start()
  //             .then(() => console.log("Connected to SignalR"))
  //             .catch(err => console.log("Connection error: ", err));

  //         console.log('signal R connected');

  //         return () => {
  //             newConnection.stop(); // Clean up on component unmount
  //         };
  //     }
  // }, [logonUserName]);
  const value = { connection, sendMessage };
  return (
    <SignalRContext.Provider value={value}>
      {children}
    </SignalRContext.Provider>
  );
};
